import React, { Component } from 'react'
// import Cookies from 'js-cookie'
import { Element as ScrollTo } from 'react-scroll'
import SEO from 'components/atoms/seo'
import { Box } from 'components/atoms/Layout'
// import Popup from 'components/organisms/Popup'
import GenericPage from 'routes/components/pages/GenericPage'
import FloatingBadge from 'routes/components/FloatingBadge'
import RentFormSlider from './RentFormSlider'
import Numbers from './Numbers'
import Comparison from './Comparison'
import ContactForm from './ContactForm'
import Cards from './Cards'
import Hero from './Hero'
import StepsSection from './StepsSection'
// import Testimonials from './Testimonials'

// const POPUP_ADD_TEXT = `
// PSST! WE ARE HAVING A SPECIAL PROMOTION TODAY! IF YOU SIGN UP NOW,WE WILL WEAVE YOUR FIRST PAYMENT!
// `
// const BUTTON_TEXT = `SEE WHAT CAN I AFFORD`

// const IS_INFO_POPUP_SHOWN_BEFORE = 'isInfoPopupShownBefore'
// const COOKIE_EXPIRATION_DAYS = 365

// TODO: enable once popup is back in the App after launch
/* eslint-disable react/prefer-stateless-function */
class Home extends Component {
  // state = {
  //   isPopupVisible: false,
  // }
  // componentDidMount = async () => {
  //   const isInfoPopupShownBefore = await Cookies.get(IS_INFO_POPUP_SHOWN_BEFORE)
  //   this.setState({ isPopupVisible: !isInfoPopupShownBefore })
  // }

  // handleShowPopup = () => {
  //   Cookies.set(IS_INFO_POPUP_SHOWN_BEFORE, true, {
  //     expires: COOKIE_EXPIRATION_DAYS,
  //   })
  //   this.setState({ isPopupVisible: false })
  // }

  render() {
    // const { isPopupVisible } = this.state
    return (
      <GenericPage
        overlayContent={
          <React.Fragment>
            <FloatingBadge />
            {/* Disabled for first public release
            <Popup
              isVisible={isPopupVisible}
              onClose={this.handleShowPopup}
              isInfo
              message={POPUP_ADD_TEXT}
              buttonText={BUTTON_TEXT}
            />
            */}
          </React.Fragment>
        }
      >
        <SEO title="Home" keywords={[`gatsby`, `application`, `react`]} />
        <Hero />
        <Box py="xl">
          <Box py="xl">
            <ScrollTo name="rent-form">
              <RentFormSlider />
            </ScrollTo>
          </Box>
          <Box py="xl">
            <Cards />
          </Box>
          <Box py="xl">
            <StepsSection />
          </Box>
          <Box py="xl">
            <Numbers />
          </Box>
          <Box py="xl">
            <Comparison />
          </Box>
          <Box py="xl">
            <ContactForm />
          </Box>
          {/* <Box py="xl">
            <Testimonials />
          </Box> */}
        </Box>
      </GenericPage>
    )
  }
}

export default Home
